



















import { Component, Vue } from 'vue-property-decorator'

@Component
export default class RequestAndLoad extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
  user = (this.$f7route!.context as any).user

  created () {
    // console.log('request-and-load created')
    // console.log('request-and-load SHOULD HAVE route.context.user')
  }

  mounted () {
    // console.log('request-and-load mounted')
  }
}
